// 应用入口文件，负责初始化 Vue 实例及注册全局插件
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Vant from 'vant'
import echarts from 'echarts'
import VueIntro from 'vue-introjs'
import '@/assets/icons/iconfont.css'
import '@/assets/custom-theme/index.css'
import '@/icons'
import 'element-ui/lib/theme-chalk/index.css'
import 'vant/lib/index.css'
import 'intro.js/introjs.css'

Vue.config.productionTip = false

// 注册全局插件
Vue.use(ElementUI)
Vue.use(Vant)
Vue.use(VueIntro)

// 将 echarts 挂载到 Vue 原型上，方便全局使用
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
